import {
  addDays,
  addWeeks,
  endOfDay,
  endOfMonth,
  endOfWeek,
  setHours,
  setMinutes,
  startOfDay,
  startOfMonth,
  startOfWeek,
} from 'date-fns'
import { WeekDays } from '@pogokid/util/datetime'
import { DayHours, SchedulerView, SelectedRange } from '../types'

export function getVisibleRange(
  view: SchedulerView,
  selectedDate: Date,
  weekStartsOn: WeekDays = 0,
  dayStartHour: DayHours = 0,
  dayEndHour: DayHours = 23,
  plusDays: number = 0
): SelectedRange {
  switch (view) {
    case 'month':
      return getVisibleMonthRange(selectedDate)
    case 'weekday':
      return getVisibleWeekDayRange(selectedDate, 7)
    case 'week':
      return getVisibleWeekRange(selectedDate, weekStartsOn)
    case 'day':
      return getVisibleDayRange(
        selectedDate,
        dayStartHour,
        dayEndHour,
        plusDays
      )
  }
}

export function getVisibleMonthRange(
  selectedDate: Date
): SelectedRange {
  return {
    start: startOfMonth(selectedDate),
    end: endOfMonth(selectedDate),
  }
}

export function getVisibleWeekRange(
  selectedDate: Date,
  weekStartsOn: WeekDays = 0
): SelectedRange {
  return {
    start: startOfWeek(selectedDate, { weekStartsOn }),
    end: endOfWeek(selectedDate, { weekStartsOn }),
  }
}

export function getVisibleWeekDayRange(
  selectedDate: Date,
  visibleWeeks: number = 7
): SelectedRange {
  const start = startOfDay(selectedDate)
  return {
    start,
    end: endOfDay(addWeeks(start, visibleWeeks - 1)),
  }
}

export function getVisibleDayRange(
  selectedDate: Date,
  startHour: DayHours,
  endHour: DayHours,
  plusDays: number = 0
): SelectedRange {
  return {
    start: setMinutes(
      setHours(startOfDay(selectedDate), startHour),
      0
    ),
    end: setMinutes(
      setHours(
        endOfDay(
          plusDays > 0
            ? addDays(selectedDate, plusDays)
            : selectedDate
        ),
        endHour
      ),
      0
    ),
  }
}
